export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11474.df8110ed.jpg";